export default "__VITE_ASSET__BMtd2jx___"